
<div class="marketplace-wrapper" :class="marketplaceLayout">
  <main-nav :title="$t('editor.header.marketplace.title')" />
  <cvt-popup-choose-template :mode="mode" />
</div>
